<template>
  <v-container fluid>
    <h2 class="mb-5">
      {{ pazymaTitle
      }}<el-tooltip
        inline
        :tooltip="`${pazymaTooltipPrefix} Anotacija`"
        external
        @activate="
          eventPayload =>
            showAprasymas(eventPayload, `${pazymaTooltipPrefix} Anotacija`)
        "
      />
    </h2>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="pazymaAprasymas"
        @close="hideAprasymas"
      />
    </div>
    <el-paslauga-santrauka :tooltip="`${pazymaTooltipPrefix} Santrauka`" />

    <v-card class="pa-0" flat>
      <el-overlay-loading :loading="pageloading" />

      <el-button
        v-if="showNaujaPazyma"
        class="mt-3 mb-5"
        :loading="naujaPazymaLoading"
        :disabled="disabledNaujaPazyma"
        @click.native.stop="uzsakytiPazyma()"
      >
        {{ uzsakytiSarasasBtn }}
      </el-button>

      <el-savitarna-alert v-if="showNaujasError" dense outlined type="error">
        {{ naujasError }}
      </el-savitarna-alert>

      <asmens-turtai
        v-if="showAsmensTurtai"
        :pazyma-kodas="pazymaKodas"
        @loaded="turtaiLoaded"
      />

      <pazymos-uzsakytos
        :key="pazymosUzsakytosKey"
        :pazyma-kodas="pazymaKodas"
        @loaded="uzsakytosLoaded"
        @edit="editPazyma"
      />
    </v-card>

    <modal-pazyma-extra
      v-model="showPazymaExtra"
      :pazyma-kodas="pazymaKodas"
      @confirmExtra="confirmExtra"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PazymaMap from './PazymaMap'
import userRole from '@/mixins/userRole'
import AsmensTurtai from './AsmensTurtai'
import PazymosUzsakytos from './PazymosUzsakytos'
import ModalPazymaExtra from './ModalPazymaExtra'

export default {
  name: 'Pazymos',
  components: {
    AsmensTurtai,
    PazymosUzsakytos,
    ModalPazymaExtra,
  },
  mixins: [userRole],
  props: {
    pazymaKodas: String,
  },
  data() {
    return {
      pazymaAprasymas: null,
      showNaujasError: false,
      naujasError: null,
      naujaPazymaLoading: false,
      turtaiLoading: true,
      uzsakytosLoading: true,
      turtasSk: null,
      yraIgaliotinis: null,
      yraNtrAsmuo: null,
      showPazymaExtra: false,
      pazymosUzsakytosKey: 0,
    }
  },
  computed: {
    ...mapGetters(['savitarnaKrepselisUrl']),
    pazymaTooltipPrefix() {
      return this.pazymaMap.tooltipPrefix
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    pazymaTipas() {
      return this.pazymaMap.tipas
    },
    pazymaTitle() {
      return this.pazymaMap.title
    },
    uzsakytiSarasasBtn() {
      return this.pazymaMap.uzsakytiSarasasBtn
    },
    pazymaRouteList() {
      return this.pazymaMap.routeList
    },
    pazymaRouteEdit() {
      return this.pazymaMap.routeEdit
    },
    showNaujaPazyma() {
      return !this.pageloading
    },
    disabledNaujaPazyma() {
      return this.isTipasSklypas && this.turtasSk == 0
    },
    pageloading() {
      return this.turtaiLoading || this.uzsakytosLoading
    },
    isTipasSklypas() {
      return this.pazymaTipas == 'zemes-sklypas'
    },
    isExtraUzsakymas() {
      return (
        (!this.isTipasSklypas || this.turtasSk == 1) &&
        this.yraIgaliotinis === false
      )
    },
    showNtrWarning() {
      return !this.isTipasSklypas && !this.yraNtrAsmuo
    },
    ntrWarning() {
      return this.$t(
        'Pažymos išdavimas savitarnoje negalimas. Daugiau informacijos galima gauti \
      atvykus į Registrų centro klientų aptarnavimo padalinį, \
      pateikus asmens tapatybę patvirtinantį dokumentą (asmens tapatybės kortelę arba pasą) \
      ir užpildžius prašymą. Jeigu prašymą pateikia įgaliotas asmuo, jis privalo pateikti \
      teisės aktų nustatyta tvarka patvirtintą įgaliojimą ir įgalioto asmens tapatybę \
      patvirtinantį dokumentą (asmens tapatybės kortelę arba pasą)'
      )
    },
    showAsmensTurtai() {
      return !this.isTipasSklypas
    },
  },
  created() {
    this.loading = true
    if (this.isTipasSklypas) {
      this.turtaiLoading = false
    }
  },
  methods: {
    showAprasymas(tipas) {
      this.pazymaAprasymas = tipas
    },
    hideAprasymas() {
      this.pazymaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
    turtaiLoaded(payload) {
      this.turtasSk = payload.turtas_sk
      this.yraIgaliotinis = payload.yra_igaliotinis
      this.yraNtrAsmuo = payload.yra_ntr_asmuo

      this.turtaiLoading = false
    },
    uzsakytosLoaded() {
      this.uzsakytosLoading = false
    },
    uzsakytiPazyma() {
      if (this.isTipasSklypas) {
        this.gotoZemesSklypai()
        return
      }

      if (this.showNtrWarning) {
        this.naujasError = this.ntrWarning
        this.showNaujasError = true
        return
      }
      if (this.isExtraUzsakymas) {
        this.showPazymaExtra = true
        return
      }

      this.naujaPazyma()
    },
    confirmExtra(response) {
      this.showPazymaExtra = false
      if (response.krepselis) {
        this.gotoKrepselis(response.krepselis_id)
        return
      }
      this.updatePazymosUzsakytos()
    },
    gotoKrepselis(krepselis_id = null) {
      this.loading = true
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
    naujaPazyma() {
      this.naujaPazymaLoading = true
      this.showNaujasError = false

      const data = {
        paz_tipas: this.pazymaTipas,
      }
      this.$axios
        .post(`ntrpaslaugos/pazyma`, data)
        .then(res => {
          this.editPazyma(res.data.pazyma)
        })
        .catch(err => {
          this.naujasError = err.response.data.message
          this.showNaujasError = true
        })
        .finally(() => {
          this.naujaPazymaLoading = false
        })
    },
    editPazyma(pazyma) {
      const pazymaID = pazyma.paz_id
      this.$store.dispatch('pazymaID', pazymaID).then(
        this.$store.dispatch('pazymaTipas', pazyma.paz_tipas).then(() => {
          const listInfo = {
            pazymaID: pazymaID,
            routeName: this.pazymaRouteList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            this.$router.push({
              name: this.pazymaRouteEdit,
              params: {
                pazymaID: pazymaID,
              },
            })
          })
        })
      )
    },
    gotoZemesSklypai() {
      const listInfo = {
        pazymaKodas: this.pazymaKodas,
        routeName: this.pazymaRouteList,
      }
      this.$store.dispatch('listInfo', listInfo).then(() => {
        this.$router.push({
          name: this.pazymaMap.routeNew,
          params: {
            pazymaKodas: this.pazymaKodas,
          },
        })
      })
    },
    updatePazymosUzsakytos() {
      this.pazymosUzsakytosKey++
    },
  },
}
</script>
<style lang="scss" scoped></style>
